import React, { useState } from "react";
import { Row, Col, Collapse } from "reactstrap";

import { useTranslation } from "react-i18next";

const Survey = ({ obj, title }) => {
  const { t } = useTranslation();
  const [collapsePreChat, setCollapsePreChat] = useState(false);

  const togglePreChat = () => {
    setCollapsePreChat((prev) => !prev);
  };

  const showPreChat = (arr) =>
    arr.map((e, idx) => (
      <Row className="mb-3 justify-content-between">
        <Col sm="5" className="font-weight-bold pr-0 text-nowrap">
          {t(e.label)}:
        </Col>
        <Col sm="5" className="pr-0">
          {t(e.message)}
        </Col>
      </Row>
    ));

  return (
    <div
      key={title}
      className={`item subitem ${collapsePreChat && "item-opened-child"}`}
    >
      <div
        className="text-wrap pointer d-flex py-3"
        onClick={() => {
          togglePreChat();
        }}
      >
        <i className="bx bx bxs-chevron-right color2 font-size-15 list-icon-child"></i>
        <div className="d-flex flex-column w-100 ml-2 pl-1">
          <div className="d-flex justify-content-between my-auto">
            <div className="d-inline-flex order-1 title font-weight-bold">
              {t(title)}
            </div>
          </div>
        </div>
      </div>
      <Collapse isOpen={collapsePreChat} className="pt-3 px-3 mx-1 my-0 border">
        {obj && Object.keys(obj).length > 0 ? (
          showPreChat(obj)
        ) : (
          <div className="text-center mb-3">
            {t("No matching records found")}
          </div>
        )}
      </Collapse>
    </div>
  );
};

export default Survey;
